import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Liquids from "@/pages/Liquids";
import GenerateLabel from "@/pages/GenerateLabel";
import Settings from "@/pages/Settings";
import Credits from "@/pages/Credits";
import Admin from "@/pages/Admin";
import Stats from "@/pages/Stats";
import LabelHistory from "@/pages/LabelHistory";
import Invoices from "@/pages/Invoices";
import SafetySheets from "@/pages/SafetySheets";
import Registry from "@/pages/Registry";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordPages";
import "@/App.css";

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/liquids" element={<ProtectedRoute><Liquids /></ProtectedRoute>} />
            <Route path="/generate" element={<ProtectedRoute><GenerateLabel /></ProtectedRoute>} />
            <Route path="/history" element={<ProtectedRoute><LabelHistory /></ProtectedRoute>} />
            <Route path="/stats" element={<ProtectedRoute><Stats /></ProtectedRoute>} />
            <Route path="/safety-sheets" element={<ProtectedRoute><SafetySheets /></ProtectedRoute>} />
            <Route path="/registry" element={<ProtectedRoute><Registry /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/credits" element={<ProtectedRoute><Credits /></ProtectedRoute>} />
            <Route path="/subscribe" element={<ProtectedRoute><Credits /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            <Route path="/invoices" element={<ProtectedRoute><Invoices /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
